import { PageTitle } from "@/components/page-title";
import { MerchantForm } from "./_form";

function MerchantNew() {
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <PageTitle>New merchant</PageTitle>
      <MerchantForm />
    </div>
  );
}

export default MerchantNew;
